import { render } from "./EncerramentoProjeto.vue?vue&type=template&id=43b2e144&scoped=true"
import script from "./EncerramentoProjeto.vue?vue&type=script&lang=js"
export * from "./EncerramentoProjeto.vue?vue&type=script&lang=js"

import "./EncerramentoProjeto.vue?vue&type=style&index=0&id=43b2e144&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b2e144"]])

export default __exports__